import { apiRequest } from "api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  GET_ROLES_INFO,
  GET_USERMAILS_BY_ROLEID,
} from "./apiUrls";
import { encryptPayload } from "./encrypt";
import { BASE_URL } from "constants/routes";


export const fetchUsersWithRole = async (data) => {
  const req = GET_USERMAILS_BY_ROLEID;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  try {
    const result = await apiRequest(req, options,true);
    return result.data;
  } catch (error) {
    throw error;
  }
};

export const getRolesInfo = createAsyncThunk("users/getRolesInfo", async (data) => {
  const req = GET_ROLES_INFO;
  let params = {
    body: data
  }
  const encryptedBodyRes = await encryptPayload("",params,true,true);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try {
    const result = await encryptPayload(req, options, false, true,true);
    return result?.data;
  } catch (error) {
    throw error;
  }
});

export const createUserHierarchy = createAsyncThunk("users/createUserHierarchy", async (data) => {
  const req = `${BASE_URL}/users/createUserHierarchy`
  let params = {
    body: data
  }
  const encryptedBodyRes = await encryptPayload("",params,true,true);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try {
    const result = await encryptPayload(req, options, false, true,true);
    return result;
  } catch (error) {
    throw error;
  }
});

export const updateDropdownOptions = createAsyncThunk("users/updateDropdownOptions", async (data) => {
  const req = `${BASE_URL}/users/updateDropdownOptions`
  let params = {
    body: data
  }
  const encryptedBodyRes = await encryptPayload("",params,true,true);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try {
    const result = await encryptPayload(req, options, false, true,true);
    return result;
  } catch (error) {
    throw error;
  }
});

export const fetchUsersByCustomFilters = createAsyncThunk("users/fetchUsersByCustomFilters", async (data) => {
  const req = `${BASE_URL}/users/fetchUsersByCustomFilters`
  let params = {
    body: data
  }
  const encryptedBodyRes = await encryptPayload("",params,true,true);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try {
    const result = await encryptPayload(req, options, false, true,true);
    return result?.data;
  } catch (error) {
    throw error;
  }
});

export const checkMaxAttempts = async (data) => {
  const req = `${BASE_URL}/users/checkMaxAttempts`
  let params = {
    body: data
  }
  const encryptedBodyRes = await encryptPayload("",params,true,true);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try {
    const result = await encryptPayload(req, options, false, true,true);
    return result;
  } catch (error) {
    throw error;
  }
};

export const fetchReportingManagerInfo = async (data) => {
  const req = `${BASE_URL}/users/fetchReportingManagerInfo`
  let params = {
    body: data
  }
  const encryptedBodyRes = await encryptPayload("",params,true,true);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try {
    const result = await encryptPayload(req, options, false, true,true);
    return result;
  } catch (error) {
    throw error;
  }
};

  export const getUserNamesByIds = createAsyncThunk(
  "users/getUserNamesByIds",
  async (data) => {
    const req = `${BASE_URL}/users/getUserNamesByIds`;
    const params = { body: data }; 
    const encryptedBodyRes = await encryptPayload("", params, true, true);
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(encryptedBodyRes),
    };
    try {
    const result = await encryptPayload(req, options, false, true, true);
      const parsed = typeof result === "string" ? JSON.parse(result) : result;
      const realData = structuredClone(parsed.data); 
      return result.data;
    } catch (error) {
      throw error;
    }
  }
);



